import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { useOutletContext } from 'react-router-dom';
import Pagination from '../../components/Pagination';
import NoticeController, { NotificationType } from '../../controller/NoticeController';
import { CurrentStoreContext } from '../../controller/StoreController';

import MDEditor from '@uiw/react-md-editor';
import moment from 'moment-timezone';

import 'suneditor/dist/css/suneditor.min.css';

const NotificationIndex = () => {
  const { currentStore } = useOutletContext<CurrentStoreContext>();

  // 당일 매출건수의 페이지 개수
  const [pageCount, setPageCount] = useState<number>(0);

  const [noticeList, setNoticeList] = useState<NotificationType[]>([]);
  const [isOpen, setIsOpen] = useState<boolean[]>([]);

  const getlist = async (page: number) => {
    try {
      const oParams = {
        store_id: currentStore.value,
        item_count: 10,
        page,
      };
      const oRes = await NoticeController.getlist(oParams);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getlist', oResponse);
        if (oResponse.data) {
          setPageCount(Math.ceil(oResponse.data.totalCount / 10));
          setNoticeList([...oResponse.data.list]);
          setIsOpen(new Array(oResponse.data.list.length).fill(false));
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  const getDetail = async (notice_id: number) => {
    try {
      const oParams = {
        notice_id,
      };
      const oRes = await NoticeController.getdetail(oParams);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getDetail', oResponse);
        if (oResponse.data) {
          const noticeTemp = [...noticeList];
          const noticeIndex = noticeList.findIndex((item) => item.notice_id === notice_id);
          if (noticeIndex !== -1) {
            noticeTemp[noticeIndex].content = oResponse.data;
            setNoticeList([...noticeTemp]);
          }
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  const pressPage = async (selected: { selected: number }) => {
    await getlist(selected.selected + 1);
  };

  useEffect(() => {
    getlist(1);
  }, [currentStore]);

  interface NotificationProps {
    item: NotificationType;
    index: number;
  }

  const RenderNotificationItem = ({ item, index }: NotificationProps) => {
    const changeIsOpen = async () => {
      await getDetail(item.notice_id);
      const dataTemp = isOpen;
      dataTemp[index] = !dataTemp[index];
      setIsOpen([...dataTemp]);
    };

    return (
      <>
        <div className="listItem" onClick={changeIsOpen}>
          <div className="row between">
            <div className="row gap">
              <h3>{item.title}</h3>
              {item.wasRead === 0 && <div className="newBadge">NEW</div>}
            </div>
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_arrow_${
                isOpen[index] ? 'up' : 'down'
              }_grey.svg`}
              width={30}
              height={30}
              alt="ic"
            />
          </div>
          <h5>{moment(item.created_at).format('YYYY-MM-DD HH:mm')}</h5>
        </div>
        {isOpen[index] && (
          <div className="contentWrap" style={{ minHeight: isOpen[index] ? '200px' : '0' }}>
            {/* <MDEditor.Markdown className="markdown" source={item.content} /> */}
            <div
              className="sun-editor-editable preview"
              dangerouslySetInnerHTML={{ __html: item.content }}
            />
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <Style>
        <div className="contentContainer">
          {noticeList.length > 0 ? (
            <div className="listWrap">
              {noticeList.map((item: NotificationType, index: number) => {
                return <RenderNotificationItem key={index} item={item} index={index} />;
              })}
            </div>
          ) : (
            <div className="noneWrap">
              <h3>공지사항이 없어요</h3>
            </div>
          )}
        </div>
        <Pagination pageCount={pageCount} forcePage={0} handlePageClick={pressPage} />
      </Style>
    </>
  );
};

export default NotificationIndex;

const Style = styled.div`
  @font-face {
    font-family: '고운 돋음';
    src: url('${process.env.PUBLIC_URL}/font/Dodum-Regular.ttf') format('truetype');
  }
  @font-face {
    font-family: '고운 바탕';
    src: url('${process.env.PUBLIC_URL}/font/Batang-Regular.ttf') format('truetype');
  }
  @font-face {
    font-family: 'G마켓 산스';
    src: url('${process.env.PUBLIC_URL}/font/GmarketSansTTF.ttf') format('truetype');
  }
  @font-face {
    font-family: '청주김생체';
    src: url('${process.env.PUBLIC_URL}/font/ChungjuKimSaeng.ttf') format('truetype');
  }
  @font-face {
    font-family: '여기어때 잘난체';
    src: url('${process.env.PUBLIC_URL}/font/Jalnan2TTF.ttf') format('truetype');
  }

  p {
    font-family: 'Pretendard';
    font-size: 14px;
    font-weight: 500;
    color: #000;
  }
  .listWrap {
    display: flex;
    flex-direction: column;

    .listItem {
      padding: 14px 0;
      border-bottom: 1px solid #e5e5e5;
      cursor: pointer;

      .row.gap {
        gap: 10px;
      }

      .row.between {
        padding-bottom: 10px;
        h3 {
          font-size: 20px;
          line-height: 24px;
          font-weight: 600;
          color: #555555;
        }
      }
      h5 {
        color: #979797;
        font-weight: 500;
      }
    }

    .markdown {
      background: #f7f7f7;
    }

    .newBadge {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50px;
      padding: 4px 12px;
      background: #ff3542;
      font-size: 14px;
      line-height: 16px;
      color: #ffffff;
      font-weight: 500;
    }

    .contentWrap {
      background: #f7f7f7;
      padding: 0 2px 2px 2px;
      h4 {
        color: #555555;
        font-weight: 400;
        white-space: normal;
        word-break: break-all;
      }
    }
  }

  .sun-editor-editable {
    min-height: 200px;
  }

  .black {
    .sun-editor-editable,
    .preview {
      border: 1px solid #cecece;
      background-color: #000;
      color: #fff;

      hr {
        border-color: #fff;
      }

      thead {
        border-bottom: 2px solid #fff;
      }
      tr,
      td,
      th {
        border: 1px solid #fff !important;
      }
      th {
        background-color: #555;
      }
    }
  }
`;
